import { FC } from 'react';
import { ProviderFolderIcon } from '../atoms/icons/ProviderFolderIcon';

interface ProviderAvatarProps {
  name?: string;
  size?: number;
  unassigned?: boolean;
}

const UNASSIGNED_BG = 'var(--color-fletchers-gray-110)';
const UNASSIGNED_GLYPH = 'var(--color-fletchers-gray-200)';
const ASSIGNED_BG = 'var(--color-fletchers-green-50)';
const ASSIGNED_GLYPH = 'var(--color-fletchers-green-600)';

export const ProviderAvatar: FC<ProviderAvatarProps> = ({ size = 32, unassigned = false }) => {
  const backgroundColor = unassigned ? UNASSIGNED_BG : ASSIGNED_BG;
  const iconColor = unassigned ? UNASSIGNED_GLYPH : ASSIGNED_GLYPH;

  return (
    <div
      className="flex shrink-0 items-center justify-center rounded-full"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        backgroundColor,
      }}
    >
      <ProviderFolderIcon
        style={{
          color: iconColor,
          width: `${size * 0.6}px`,
          height: `${size * 0.6}px`,
        }}
      />
    </div>
  );
};
